module.exports = __webpack_public_path__ + "fonts/TitilliumWeb-Italic.eot";